var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThreeEllipseWhite = function SvgThreeEllipseWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "menu-item-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.255,
    height: 32.301
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "three-ellipse-white_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 21274",
    fill: "#fff",
    d: "M0 0h22.255v32.301H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Logo Vector",
    clipPath: "url(#three-ellipse-white_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108543",
    d: "M0 16.055A16.168 16.168 0 0 1 16.15 0h1.182v2.566H16.15A13.6 13.6 0 0 0 2.566 16.055Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108544",
    d: "M4.923 32.3v-2.566h1.175a13.6 13.6 0 0 0 13.584-13.489h2.566A16.168 16.168 0 0 1 6.098 32.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108545",
    d: "M4.923 27.377v-2.566h1.175a8.671 8.671 0 0 0 8.668-8.566h2.566A11.24 11.24 0 0 1 6.098 27.377Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108546",
    d: "M4.923 16.055A11.242 11.242 0 0 1 16.15 4.923h1.182v2.566H16.15a8.672 8.672 0 0 0-8.661 8.566Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108547",
    d: "M4.923 22.456v-2.568h1.175a3.741 3.741 0 0 0 3.743-3.642v-.1a6.311 6.311 0 0 1 6.31-6.3h1.182v2.566H16.15a3.743 3.743 0 0 0-3.736 3.643v.1a6.313 6.313 0 0 1-6.317 6.306Z"
  }))));
};
export default SvgThreeEllipseWhite;